import initializeGoogleAd from 'google_ads/initializer'

initializeGoogleAd()
